// Fixed fallback so the seeded picks stay deterministic when no transport seed arrives.
export const FallbackRandomSeed = "fallback seed";
